export async function RunFredflixFlow(email, action, extraData) {
    let result = {};
    try {
        const response = await fetch(
            'https://wm.frederon.com/api/r/fredflix_flow',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    'email': email,
                    'action': action,
                    'extradata': extraData,
                })
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        result = data;
    } catch (error) {
        console.error('Error fetching user data:', error);
    }

    return result;
}
